import React from 'react'
import {Button, Grid, Paper, Snackbar, TextField} from '@mui/material'
import ListItemText from "@mui/material/ListItemText";
import makeStyles from '@mui/styles/makeStyles';
import MuiAlert from '@mui/material/Alert';
import MessengerIcon from "../../assets/icons/ic_messenger.svg";

import {BASE_URL_MESSENGER_API} from "../../Const";


const useStyles = makeStyles(theme => ({
    labelRoot: {
        right: 0
    },
    shrink: {
        transformOrigin: "top right"
    }
}));

const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export class OtpMessengerComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            phone: "",
            redirect: false,
            openSnackbar: false,
            message: "",

        }
    }


    FormPropsTextFields = () => {

        const handleOnchange = (e) => {
            this.setState({phone: e.target.value})
        }


        const classes = useStyles();

        return (
            <div>
                <TextField
                    fullWidth
                    required
                    onChange={handleOnchange}
                    style={{direction: "rtl", marginTop: 48}}
                    id="standard-required"
                    label="شماره تلفن"
                    placeholder="09123456789"
                    InputLabelProps={{
                        classes: {root: classes.labelRoot, shrink: classes.shrink}
                    }}
                />
            </div>
        );
    }

    onSubmit = (e) => {

        fetch(BASE_URL_MESSENGER_API + 'lookup', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*'
            },
            body: JSON.stringify({
                phone: this.state.phone,
            })
        }, {mode: 'no-cors'})
            .then(response => response.json())
            .then(result => {
                if (result.code === "200") {
                    localStorage.setItem("pwa_temp_user_messenger_token", result.data.temporary_token)
                    window.location.assign('messenger/login');
                } else {
                    this.setState({openSnackbar: true, message: result.message})
                }

            })
    }

    render() {

        const paperStyle = {padding: 20, height: '70vh', width: 280, margin: "20px auto"}
        const btnStyle = {marginTop: 24, backgroundColor: '#FF1744', color: 'white'}

        const handleCloseSnackbar = (e) => {
            this.setState({openSnackbar: false})
        }
        return (
            <Grid>
                <Paper elevation={10} style={paperStyle}>
                    <Grid align='center'>
                        <img alt={""} width={96} height={96} src={MessengerIcon}/>
                        <ListItemText>ورود به پیام‌رسان</ListItemText>
                    </Grid>
                    <this.FormPropsTextFields/>

                    <Button onClick={this.onSubmit} type='submit' variant="contained" style={btnStyle} fullWidth>ارسال
                        کد</Button>
                </Paper>

                <Snackbar open={this.state.openSnackbar} autoHideDuration={6000} onClose={handleCloseSnackbar}>
                    <Alert onClose={handleCloseSnackbar} severity="error" sx={{width: '100%'}}>
                        {this.state.message}
                    </Alert>
                </Snackbar>
            </Grid>
        );
    }


}
